import { render, staticRenderFns } from "./LwfCheckbox.vue?vue&type=template&id=f259346e&scoped=true&"
import script from "./LwfCheckbox.vue?vue&type=script&lang=js&"
export * from "./LwfCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f259346e",
  null
  
)

export default component.exports
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QCheckbox});
